import React, { useState, useEffect } from 'react';
import { useAuth } from '../lib/store';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('session') === 'expired') {
      setError('Your session expired. Please log in again.');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAF7] px-4" data-testid="login-page">
      <div className="w-full max-w-md animate-fade-in">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_quick-quote-25/artifacts/lc3jnw3x_Hedaply%20Logo.jpg"
            alt="HEDA PLYWOODS"
            className="h-20 mx-auto mb-4"
            data-testid="login-logo"
          />
          <p className="text-sm text-[#5C6150] font-medium tracking-wide uppercase">Smart Quotation System</p>
        </div>

        <Card className="border-[#E2E6D9] shadow-lg">
          <CardContent className="pt-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-[#1A1C16] font-medium text-sm">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 bg-[#F9FAF7] border-[#E2E6D9] focus:border-[#556B2F] focus:ring-[#DAA520]/20"
                  data-testid="login-email-input"
                  required
                />
              </div>
              <div>
                <Label htmlFor="password" className="text-[#1A1C16] font-medium text-sm">Password</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  className="mt-1 bg-[#F9FAF7] border-[#E2E6D9] focus:border-[#556B2F] focus:ring-[#DAA520]/20"
                  data-testid="login-password-input"
                  required
                />
              </div>

              {error && (
                <p className="text-sm text-[#B93838] bg-red-50 p-2 rounded" data-testid="login-error">{error}</p>
              )}

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-[#556B2F] hover:bg-[#465926] text-white uppercase tracking-wider font-semibold text-sm h-11"
                data-testid="login-submit-button"
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
